import { render, staticRenderFns } from "./AccountsData.vue?vue&type=template&id=553ba2ee"
import script from "./AccountsData.vue?vue&type=script&lang=js"
export * from "./AccountsData.vue?vue&type=script&lang=js"
import style0 from "./AccountsData.vue?vue&type=style&index=0&id=553ba2ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports